import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { AutopilotAutomationBaseComponent } from '@tv3/containers/automations/automations-wizard/short-automations/autopilot-automation.component'
import { AutomationHandler, AutomationTypes } from '@tokeet-frontend/automations'
import { FormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms'
import { Actions, ofType } from '@ngrx/effects'
import { ConfirmDialogService, SaveForm, untilDestroy } from '@tokeet-frontend/tv3-platform'
import { Store } from '@ngrx/store'
import { AmplitudeService } from '@tv3/services/amplitude.service'
import {
  AutomationWizardCloseAction,
  AutomationWizardSaveAction,
} from '@tv3/containers/automations/automations-wizard/automations-wizard.actions'
import { filter } from 'rxjs/operators'

@Component({
  selector: 'app-new-incident-automation',
  templateUrl: './new-incident-automation.component.html',
  styleUrls: ['./new-incident-automation.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NewIncidentAutomationComponent extends AutopilotAutomationBaseComponent implements OnInit {
  @Input() type = AutomationTypes.Incident
  @Input() handler = AutomationHandler.IncidentCreateHandler

  _incidentData: any
  // predefined incident data
  @Input() set incident(data: any) {
    this.form.patchValue({ data }, { emitEvent: false })
    this._incidentData = data
  }

  get incident() {
    return this._incidentData
  }

  constructor(
    private actions: Actions,
    protected store: Store<any>,
    protected amplitudeService: AmplitudeService,
    protected confirm: ConfirmDialogService
  ) {
    super(store, amplitudeService, confirm)
    this.form.addControl('data', new UntypedFormControl())
  }

  ngOnInit(): void {
    super.ngOnInit()

    this.automation$.pipe(untilDestroy(this)).subscribe((item) => {
      this.form.patchValue(
        {
          data: item?.settings?.incident || this.incident,
        },
        { emitEvent: false }
      )
    })

    this.actions
      .pipe(
        ofType(AutomationWizardSaveAction),
        filter(() => this.viewType !== 'table'),
        untilDestroy(this)
      )
      .subscribe((action) => {
        if (this.automationGroup) {
          this.doSave(this.form, action.closeAfterSave)
        } else if (action.closeAfterSave) {
          this.store.dispatch(AutomationWizardCloseAction())
        }
      })
  }

  tryToCreateOrUpdateAutomation(status: boolean) {
    if (this.automationGroup) {
      this.toggleAutomation(status)
    } else {
      this.doSave(this.form)
    }
  }

  @SaveForm()
  doSave(form: UntypedFormGroup, closeAfterSave = false) {
    this.saveAutomation(form.getRawValue())
    if (closeAfterSave) {
      this.store.dispatch(AutomationWizardCloseAction())
    }
  }

  getAutopilotId() {
    return `autopilot-incident|${this.service}|${this.type}|${this.event}|${this.handler}|${this.idSuffix || ''}`
  }

  onSaveData(data: any) {
    this.form.get('data').setValue(data, { emitEvent: false })
    this.doSave(this.form)
  }
}
